<template>
  <b-container fluid>
    <div class="d-flex align-items-center justify-content-around">
      <div class="bg-light box d-flex flex-column justify-content-around">

        <div class="text-uppercase"><span class="text-nowrap">Franz Schwerdtmann</span> vs. <span
          class="text-nowrap">Clemens Werner</span></div>
        <div>Light-Heavyweight</div>
        <div class="text-danger">Round 2 - 2:37</div>
      </div>
      <FaIcon icon="angle-double-right" size="5x"/>
      <div class="bg-primary box d-flex flex-column justify-content-around text-light">
        <div>Next Match #4</div>
        <div class="text-uppercase"><span class="text-nowrap">Leon Mark</span> vs. <span
          class="text-nowrap">Andy Rudolph</span></div>
        <div>Light-Heavyweight</div>
      </div>
    </div>

    <h2>Upcoming Matches</h2>
    <b-row>
      <b-col>
        <b-table
          class="schedule"
          :fields="fields"
          :items="matches.slice(0, 10)"
          head-variant="dark"
          small
        ></b-table>
      </b-col>
      <b-col>
        <b-table
          :fields="fields"
          :items="matches.slice(10, 20)"
          head-variant="dark"
          small
        ></b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'TVSchedule',
  data() {
    return {
      fields: ['id', 'weightClass', 'redCorner', 'blueCorner'],
      matches: [
        {
          id: '1',
          type: 'Matchfight',
          weightClass: 'Lightweight',
          redCorner: 'Franz Schwerdtmann',
          blueCorner: 'Clemens Werner',
        },
        {
          id: '2',
          type: 'Tournament',
          weightClass: 'Lightweight',
          redCorner: 'A',
          blueCorner: 'J',
        },
        {
          id: '3',
          type: 'Tournament',
          weightClass: 'Lightweight',
          redCorner: 'B',
          blueCorner: 'I',
        },
        {
          id: '4',
          type: 'Matchfight',
          weightClass: 'Welterweight',
          redCorner: 'C',
          blueCorner: 'H',
        },
        {
          id: '5',
          type: 'Tournament',
          weightClass: 'Welterweight',
          redCorner: 'D',
          blueCorner: 'G',
        },
        {
          id: '6',
          type: 'Tournament',
          weightClass: 'Middleweight',
          redCorner: 'E',
          blueCorner: 'F',
        },
        {
          id: '6',
          type: 'Tournament',
          weightClass: 'Middleweight',
          redCorner: 'E',
          blueCorner: 'F',
        },
        {
          id: '6',
          type: 'Tournament',
          weightClass: 'Middleweight',
          redCorner: 'E',
          blueCorner: 'F',
        },
        {
          id: '6',
          type: 'Tournament',
          weightClass: 'Middleweight',
          redCorner: 'E',
          blueCorner: 'F',
        },
        {
          id: '6',
          type: 'Tournament',
          weightClass: 'Middleweight',
          redCorner: 'E',
          blueCorner: 'F',
        },
        {
          id: '6',
          type: 'Tournament',
          weightClass: 'Middleweight',
          redCorner: 'E',
          blueCorner: 'F',
        },
        {
          id: '6',
          type: 'Tournament',
          weightClass: 'Middleweight',
          redCorner: 'E',
          blueCorner: 'F',
        },
        {
          id: '6',
          type: 'Tournament',
          weightClass: 'Middleweight',
          redCorner: 'E',
          blueCorner: 'F',
        },
        {
          id: '6',
          type: 'Tournament',
          weightClass: 'Middleweight',
          redCorner: 'E',
          blueCorner: 'F',
        },
        {
          id: '6',
          type: 'Tournament',
          weightClass: 'Middleweight',
          redCorner: 'E',
          blueCorner: 'F',
        },
        {
          id: '6',
          type: 'Tournament',
          weightClass: 'Middleweight',
          redCorner: 'E',
          blueCorner: 'F',
        },
        {
          id: '6',
          type: 'Tournament',
          weightClass: 'Middleweight',
          redCorner: 'E',
          blueCorner: 'F',
        },
        {
          id: '6',
          type: 'Tournament',
          weightClass: 'Middleweight',
          redCorner: 'E',
          blueCorner: 'F',
        },
        {
          id: '6',
          type: 'Tournament',
          weightClass: 'Middleweight',
          redCorner: 'E',
          blueCorner: 'F',
        },
      ],
    };
  },
};
</script>

<style>
  nav {
    display: none !important;
  }

  .box {
    font-size: 32px;
    margin: 50px;
    padding: 40px;
    height: 40vh;
    width: 40vw;
  }
</style>
